import React from "react";
import { withChartLogic } from "./withChartLogic";

export const REPORT_CONFIG = {
  overall: {
    title: "Full Year Indicators Overall",
    apiUrl:
      "api/sims/APPSummaryDashboard/GetFullYearAPPPerformanceOverallSearch",
    excelUrl:
      "api/sims/APPSummaryDashboard/GetFullYearAPPPerformanceOverallDetailExcel",
    isMultiSeries: true,
    hasQuarterFilter: false,
    pieValueKey: "Performance",
    achievementKey: "AchievementTotal",
    targetKey: "TargetTotal",
    performanceKey: "Performance",
    tableColumns: [
      { header: "Category", key: "Values" },
      { header: "Total Targets", key: "TargetTotal", isNumeric: true },
      {
        header: "Indicators Achieved",
        key: "AchievementTotal",
        isNumeric: true,
      },
      {
        header: "Performance %",
        key: "Performance",
        isPerformance: true,
        isNumeric: true,
      },
    ],
  },
  programmestructure: {
    title: "Full Year Indicators per Programme Structure",
    apiUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPPerformancePerPSSearch",
    excelUrl:
      "api/sims/APPSummaryDashboard/GetFullYearAPPPerformancePerPSDetailExcel",
    isMultiSeries: true,
    hasQuarterFilter: false,
    pieValueKey: "Performance",
    achievementKey: "AchievementTotal",
    targetKey: "TargetTotal",
    performanceKey: "Performance",
    tableColumns: [
      { header: "Programme Structure", key: "Values" },
      { header: "Total Targets", key: "TargetTotal", isNumeric: true },
      {
        header: "Indicators Achieved",
        key: "AchievementTotal",
        isNumeric: true,
      },
      {
        header: "Performance %",
        key: "Performance",
        isPerformance: true,
        isNumeric: true,
      },
    ],
  },
  quarterlyperformance: {
    title: "Quarterly Indicators Performance",
    apiUrl: "api/sims/APPSummaryDashboard/GetQuarterAPPPerformanceSearch",
    excelUrl:
      "api/sims/APPSummaryDashboard/GetQuarterAPPPerformanceDetailExcel",
    isMultiSeries: true,
    hasQuarterFilter: true,
    pieValueKey: "Performance",
    achievementKey: "AchievementTotal",
    targetKey: "TargetTotal",
    performanceKey: "Performance",
    tableColumns: [
      { header: "Programme Structure", key: "Values" },
      { header: "Quarter", key: "QuarterID", isNumeric: true },
      { header: "Total Indicators", key: "TotalIndicators", isNumeric: true }, // Updated here
      { header: "Quarter Target", key: "TargetTotal", isNumeric: true },
      { header: "Quarter Achieved", key: "AchievementTotal", isNumeric: true },
      {
        header: "Performance %",
        key: "Performance",
        isPerformance: true,
        isNumeric: true,
      },
    ],
  },
};

export const BarChart = withChartLogic(
  ({ chartRef }) => <div ref={chartRef} />,
  "column",
);
export const LineChart = withChartLogic(
  ({ chartRef }) => <div ref={chartRef} />,
  "line",
);
export const PieChart = withChartLogic(
  ({ chartRef }) => <div ref={chartRef} />,
  "pie",
);
